import React, { useState, useEffect } from "react";
import "./App.css";
import Shades from "./components/Shades";
import { CompactPicker,SliderPicker} from 'react-color';

import randomColor from "randomcolor";
import ShadeInput from "./components/ShadeInput";
function App() {
  const [color, setColor] = useState("#000");

  useEffect(() => {
    setColor(randomColor());
  }, []);

  const onInputChange = (value) => {
    setColor(value);
  };
  const handleChangeComplete = (color) => {
    setColor(color.hex);
  };

  return (
    <>
     <CompactPicker  
        color={ color }
        onChangeComplete={ handleChangeComplete }
      />
      <SliderPicker  
        color={ color }
        onChangeComplete={ handleChangeComplete }
      />
    <div className="App">
     
      <ShadeInput color={color} onInputChange={onInputChange} />
      <Shades color={color} />
    </div>
    <footer>Created by Nirav</footer>
    </>
  );
}

export default App;
